import React, { useEffect, useState } from "react";
import {
    Box,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Typography,
    IconButton,
    InputAdornment,
    Chip,
    Button,
    TableHead,
    TableRow,
    TableContainer,
    TableCell,
    TableBody,
    Paper,
    Table,
    TableFooter,
    Autocomplete,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel
} from "@mui/material";
import { GridPagination } from "@mui/x-data-grid";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useTheme } from "@mui/material/styles";

import { DatePicker } from "@mui/x-date-pickers";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import dayjs from "dayjs";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import ClearIcon from "@mui/icons-material/Clear";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useNavigate } from "react-router-dom";

// Utilities
let formatDate = (datestr) => {
    if (!datestr) return "-";
    let splitted = datestr.split("-");
    return `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
};

const formatMinutes = (value) => {
    if (!value || value === 0) return "0m";

    value = Number(value);

    // Split minutes (before decimal) & seconds (after decimal)
    const minutes = Math.floor(value);
    const decimal = value - minutes;

    // Convert decimal fractional part into seconds (two digits max)
    const seconds = Math.round(decimal * 100);

    // Convert full minutes to hours/mins
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    let result = "";

    if (hours > 0) {
        result += `${hours}h `;
    }
    if (mins > 0) {
        result += `${mins}m `;
    }
    if (seconds > 0) {
        result += `${seconds}s`;
    }

    return result.trim() || "0m";
};


const getStatusStyles = (status) => {
    switch (status) {
        case "Pending":
            return { backgroundColor: "#FFF4CC", color: "#B38700" }; // yellow
        case "In Progress":
            return { backgroundColor: "#D6E4FF", color: "#084298" }; // blue
        case "In Review":
            return { backgroundColor: "#EDE7F6", color: "#5E35B1" }; // purple
        case "Approved":
            return { backgroundColor: "#D1F2EB", color: "#0E6251" }; // green
        case "Rejected":
            return { backgroundColor: "#FADBD8", color: "#922B21" }; // red
        case "Completed":
            return { backgroundColor: "#D4EFDF", color: "#1D8348" }; // dark green
        case "Blocked":
            return { backgroundColor: "#FDEDEC", color: "#C0392B" }; // strong red
        default:
            return { backgroundColor: "#E0E0E0", color: "#424242" }; // grey
    }
};

const InProgessTasks = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { userData, reporting_manager_employees, reporting_manager_interns } = useAuthStore();
    const org = userData?.organization;
    const loginUserOrgPersonId = userData?.loginuser?.[0]?.organization_person_id;

    // Load saved filters from localStorage
    const storedEmployee = localStorage.getItem("ipt_selected_employee") || "";
    const storedPersonType = localStorage.getItem("ipt_selected_person_type") || "1";

    const [employees, setEmployees] = useState([]);
    const [allPersons, setAllPersons] = useState([]);
    const [selectedPersonType, setSelectedPersonType] = useState(storedPersonType);
    const [selectedEmployee, setSelectedEmployee] = useState(storedEmployee);

    const [tasks, setTasks] = useState([]);
    const [pagination, setPagination] = useState({
        page: 0,
        pageSize: 10,
        total: 0,
    });
    const [loading, setLoading] = useState(false);

    // 🔥 Save filters to localStorage
    useEffect(() => {
        localStorage.setItem("ipt_selected_person_type", selectedPersonType);
    }, [selectedPersonType]);

    useEffect(() => {
        localStorage.setItem("ipt_selected_employee", selectedEmployee);
    }, [selectedEmployee]);

    // ---------------- Fetch Employees --------------------
    const fetchEmployees = async () => {
        try {
            const res = await axios.get(`${MAIN_URL}/api/organizations/${org.organization_id}/persons-data-all`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            setAllPersons(res.data.persons || []);
        } catch (err) {
            console.error("Failed to fetch employees", err);
        }
    };

    // Filter employees based on selected person type
    useEffect(() => {
        const filteredPersons = allPersons.filter(
            (person) => person.organization_person?.person_type_id === Number(selectedPersonType)
        );

        const sortedEmps = [...filteredPersons].sort((a, b) =>
            (`${a.first_name} ${a.last_name} - ${a.organization_person?.person_code}` || "").localeCompare(`${b.first_name} ${b.last_name} - ${b.organization_person?.person_code}` || "")
        );

        setEmployees(sortedEmps);
        // Reset selected employee when person type changes
        setSelectedEmployee("");
    }, [selectedPersonType, allPersons]);




    // ---------------- Fetch Tasks ------------------------
    const fetchTasks = async () => {
        if (!org?.organization_id) return;
        setLoading(true);

        try {
            const params = {
                organization_id: org.organization_id,
                page: pagination.page + 1,
                per_page: pagination.pageSize,
                status: "In Progress",
                date: dayjs().format("YYYY-MM-DD"),
                // Always send person_type_id to filter by Employee (1) or Intern (2)
                person_type_id: selectedPersonType || "1",
            };

            // Only send organization_person_id if a specific person is selected; otherwise show all org tasks
            if (selectedEmployee && selectedEmployee !== "") {
                params.organization_person_id = selectedEmployee;
            }

            const today = dayjs();
            const cutoffDate = dayjs("2025-12-26", "YYYY-MM-DD");

            // const endpoint = today.isSameOrAfter(cutoffDate, "day")
            //     ? "employee-tasks-v1"
            //     : "employee-tasks";
const endpoint = "employee-tasks-v1"
 
            const res = await axios.get(
                `${MAIN_URL}/api/project-management/project-tasks/${endpoint}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    params,
                }
            );

            setTasks(res.data.data?.data || []);

            setPagination((prev) => ({
                ...prev,
                total: res.data.data?.total || 0,
            }));
        } catch (err) {
            console.error("Failed to fetch tasks", err);
        }

        setLoading(false);
    };



    useEffect(() => {
        fetchEmployees();
    }, []);

    useEffect(() => {
        fetchTasks();
    }, [selectedEmployee, selectedPersonType, pagination.page, pagination.pageSize]);


    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        const updatedTasks = Array.from(tasks);

        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;

        const sourceTask = updatedTasks[sourceIndex];
        const destTask = updatedTasks[destIndex];

        // Swap the correct field
        const temp = sourceTask.task_order;
        sourceTask.task_order = destTask.task_order;
        destTask.task_order = temp;

        // Reorder array visually
        updatedTasks.splice(sourceIndex, 1);
        updatedTasks.splice(destIndex, 0, sourceTask);

        setTasks(updatedTasks);

        // 🔥 API CALL
        try {
            await axios.post(
                `${MAIN_URL}/api/project-management/project-tasks/swap-order`,
                {
                    organization_id: org?.organization_id,
                    task1_id: sourceTask.organization_project_task_id,
                    task1_order: sourceTask.task_order,
                    task2_id: destTask.organization_project_task_id,
                    task2_order: destTask.task_order,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
        } catch (err) {
            console.error("Order update failed", err);
        }
    };


    // ---------------- Summary Totals ------------------------
    const totalAllocated = tasks.reduce(
        (sum, t) => sum + (t.total_estimated_minutes || 0),
        0
    );

    const totalLogged = tasks?.reduce(
        (sum, t) => {
            const val = t.calculated_actual_minutes;

            // Ignore null, undefined, 0, or negative values
            if (!val || val <= 0) return sum;

            return sum + val;
        },
        0
    );


    console.log("totalLogged is : ", totalLogged);

    console.log("tasks issss : ", tasks);



    // ---------------- Render ------------------------

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                In Progess Tasks of "{dayjs().format("DD-MM-YYYY")}"
            </Typography>
            <br />

            {/* Filters */}
            <Box display="flex" gap={2} alignItems="center" mb={2}>
                {/* Person Type Filter */}
                <FormControl>
                    <FormLabel>Person Type</FormLabel>
                    <RadioGroup
                        row
                        value={selectedPersonType}
                        onChange={(e) => {
                            setSelectedPersonType(e.target.value);
                            setPagination((prev) => ({ ...prev, page: 0 }));
                        }}
                    >
                        <FormControlLabel value="1" control={<Radio />} label="Employee" />
                        <FormControlLabel value="2" control={<Radio />} label="Intern" />
                    </RadioGroup>
                </FormControl>

                {/* Employee Filter */}
                <Autocomplete
                    fullWidth
                    options={[
                        { label: `All ${selectedPersonType === "1" ? "Employees" : "Interns"}`, value: "" },
                        ...employees.map((emp) => ({
                            label: `${emp.first_name} ${emp.last_name} - ${emp.organization_person?.person_code}`,
                            value: emp.organization_person?.organization_person_id
                        }))
                    ]}
                    value={
                        selectedEmployee === ""
                            ? { label: `All ${selectedPersonType === "1" ? "Employees" : "Interns"}`, value: "" }
                            : employees.find((emp) => emp.organization_person?.organization_person_id === selectedEmployee)
                                ? {
                                    label: `${employees.find((emp) => emp.organization_person?.organization_person_id === selectedEmployee)?.first_name} ${employees.find((emp) => emp.organization_person?.organization_person_id === selectedEmployee)?.last_name} - ${employees.find((emp) => emp.organization_person?.organization_person_id === selectedEmployee)?.organization_person?.person_code}`,
                                    value: selectedEmployee
                                }
                                : { label: `All ${selectedPersonType === "1" ? "Employees" : "Interns"}`, value: "" }
                    }
                    onChange={(e, newValue) => {
                        setSelectedEmployee(newValue?.value || "");
                        setPagination((prev) => ({ ...prev, page: 0 }));
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                        <TextField {...params} label={`Select ${selectedPersonType === "1" ? "Employee" : "Intern"}`} />
                    )}
                />
            </Box>




            <div style={{ width: "100%" }}>

                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="taskTable">
                        {(provided) => (
                            <TableContainer component={Paper}>
                                <Table ref={provided.innerRef} {...provided.droppableProps}>

                                    {/* HEADER */}
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell><b>Project</b></TableCell>
                                            <TableCell><b>Task</b></TableCell>
                                            <TableCell><b>Qty</b></TableCell>
                                            <TableCell><b>Scheduled Date</b></TableCell>
                                            <TableCell><b>{selectedPersonType === "1" ? "Employee" : "Intern"}</b></TableCell>
                                            <TableCell><b>Allocated</b></TableCell>
                                            <TableCell><b>Logged</b></TableCell>
                                            <TableCell><b>Status</b></TableCell>
                                            <TableCell><b>Action</b></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {tasks?.map((task, index) => (
                                            <Draggable
                                                draggableId={String(task.organization_project_task_id)}
                                                index={index}
                                                key={task.organization_project_task_id}
                                            >
                                                {(draggable, snapshot) => (
                                                    <TableRow
                                                        ref={draggable.innerRef}
                                                        {...draggable.draggableProps}
                                                        {...draggable.dragHandleProps}
                                                        sx={{
                                                            cursor: "grab",
                                                            transition: "background-color 0.2s ease",

                                                            // Hover effect
                                                            "&:hover": {
                                                                backgroundColor: "#f5f5f5",
                                                            },

                                                            // While dragging effect
                                                            backgroundColor: snapshot.isDragging ? "#eeeeee" : "inherit",
                                                        }}
                                                    >
                                                        <TableCell>⋮⋮</TableCell>

                                                        <TableCell>{task.project?.project_name || "-"}</TableCell>

                                                        <TableCell>{task.task_title}</TableCell>
                                                        <TableCell>{task.quantity}</TableCell>

                                                        <TableCell>{formatDate(task.scheduled_date)}</TableCell>

                                                        <TableCell>
                                                            {task.assigned_organization_person?.person
                                                                ? `${task.assigned_organization_person.person.first_name} ${task.assigned_organization_person.person.last_name}`
                                                                : "-"}
                                                        </TableCell>

                                                        <TableCell>
                                                            {formatMinutes(task.total_estimated_minutes)}
                                                        </TableCell>

                                                        <TableCell
                                                            width={"100px"}
                                                            sx={{
                                                                color:
                                                                    task.calculated_actual_minutes > task.total_estimated_minutes
                                                                        ? "red"
                                                                        : "green",
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {formatMinutes(task.calculated_actual_minutes || 0)}
                                                        </TableCell>

                                                        <TableCell>
                                                            <Chip
                                                                label={task.status}
                                                                size="small"
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    textTransform: "capitalize",
                                                                    ...getStatusStyles(task.status),
                                                                }}
                                                            />
                                                        </TableCell>



                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                onClick={() =>
                                                                    navigate(`/project-task/view/${task.organization_project_task_id}`)
                                                                }
                                                            >
                                                                View
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </Draggable>
                                        ))}

                                        {provided.placeholder}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow
                                            sx={{
                                                bgcolor: theme.palette.action.hover,        // auto switches for dark/light
                                                borderTop: `1px solid ${theme.palette.divider}`,
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {/* Blank columns to align correctly */}
                                            <TableCell />
                                            <TableCell />
                                            <TableCell />
                                            <TableCell />
                                            <TableCell />
                                            <TableCell />

                                            {/* Allocated Column */}
                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                {formatMinutes(totalAllocated)}
                                            </TableCell>

                                            {/* Logged Column */}
                                            <TableCell sx={{ fontWeight: "bold" }}>
                                                {formatMinutes(totalLogged)}
                                            </TableCell>
                                            {/* Status column (blank) */}
                                            <TableCell />


                                            {/* Action Column (blank) */}
                                            <TableCell />
                                        </TableRow>
                                    </TableFooter>

                                </Table>
                            </TableContainer>
                        )}
                    </Droppable>
                </DragDropContext>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p={2}
                    sx={{
                        borderTop: `1px solid ${theme.palette.divider}`,
                        background: theme.palette.background.paper,
                        borderRadius: 1,
                    }}
                >
                    {/* Rows Per Page */}
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body2">Rows per page:</Typography>

                        <Select
                            size="small"
                            value={pagination.pageSize}
                            onChange={(e) =>
                                setPagination((prev) => ({
                                    ...prev,
                                    pageSize: e.target.value,
                                    page: 0,
                                }))
                            }
                            sx={{ width: 80 }}
                        >
                            {[5, 10, 20, 50, 100]?.map((size) => (
                                <MenuItem key={size} value={size}>
                                    {size}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>

                    {/* Page Info */}
                    <Typography variant="body2">
                        Page <b>{pagination.page + 1}</b> of{" "}
                        <b>{Math.ceil(pagination.total / pagination.pageSize) || 1}</b>
                    </Typography>

                    {/* Navigation */}
                    <Box display="flex" alignItems="center" gap={1}>
                        {/* First Page */}
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={pagination.page === 0}
                            onClick={() =>
                                setPagination((prev) => ({ ...prev, page: 0 }))
                            }
                        >
                            ⏮
                        </Button>

                        {/* Previous */}
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={pagination.page === 0}
                            onClick={() =>
                                setPagination((prev) => ({ ...prev, page: prev.page - 1 }))
                            }
                        >
                            ◀
                        </Button>

                        {/* Page Numbers */}
                        <Box display="flex" alignItems="center" gap={0.5}>
                            {Array.from({
                                length: Math.ceil(pagination.total / pagination.pageSize),
                            })
                                .slice(
                                    Math.max(0, pagination.page - 2),
                                    pagination.page + 3
                                )
                                .map((_, idx) => {
                                    const pageNum = Math.max(0, pagination.page - 2) + idx;

                                    return (
                                        <Button
                                            key={pageNum}
                                            variant={
                                                pagination.page === pageNum
                                                    ? "contained"
                                                    : "outlined"
                                            }
                                            size="small"
                                            onClick={() =>
                                                setPagination((prev) => ({
                                                    ...prev,
                                                    page: pageNum,
                                                }))
                                            }
                                            sx={{ minWidth: 36 }}
                                        >
                                            {pageNum + 1}
                                        </Button>
                                    );
                                })}
                        </Box>

                        {/* Next */}
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={
                                (pagination.page + 1) * pagination.pageSize >=
                                pagination.total
                            }
                            onClick={() =>
                                setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
                            }
                        >
                            ▶
                        </Button>

                        {/* Last Page */}
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={
                                (pagination.page + 1) * pagination.pageSize >=
                                pagination.total
                            }
                            onClick={() =>
                                setPagination((prev) => ({
                                    ...prev,
                                    page:
                                        Math.ceil(pagination.total / pagination.pageSize) - 1,
                                }))
                            }
                        >
                            ⏭
                        </Button>
                    </Box>
                </Box>


            </div>


        </Box>
    );
};

export default InProgessTasks;

